module.exports = __webpack_public_path__ + "img/borderLeftLongWhite.69ccdc7e.svg";